import { FC } from 'react';

import TShapeNorth from '../../../../../../../assets/icons/shapes/t-shape/t-shape-1.svg?react';
import TShapeEast from '../../../../../../../assets/icons/shapes/t-shape/t-shape-2.svg?react';
import TShapeSouth from '../../../../../../../assets/icons/shapes/t-shape/t-shape-3.svg?react';
import TShapeWest from '../../../../../../../assets/icons/shapes/t-shape/t-shape-4.svg?react';
import { Himmelretning } from '../../../../../utils/registerEnums';

import { ShapeProps } from './types';

export const TShape: FC<ShapeProps> = ({ direction }) => {
  switch (direction) {
    case Himmelretning.Nord:
      return <TShapeNorth />;
    case Himmelretning.Ost:
      return <TShapeEast />;
    case Himmelretning.Sor:
      return <TShapeSouth />;
    case Himmelretning.Vest:
      return <TShapeWest />;

    default:
      return <TShapeNorth />;
  }
};
